import React from 'react';
import { TFunction } from 'i18next';
import { FormChecklistTemplate } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import { CellProps } from '@lib/components/Table/types';
import CollapseCell from '@lib/components/Table/commonComponents/CollapseCell/CollapseCell';
import TextLinkCell from '@lib/components/Table/commonComponents/TextLinkCell/TextLinkCell';

type ColumnsArgs = {
  onOpen: (item?: FormChecklistTemplate) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableColumns({ onOpen, t }: ColumnsArgs) {
  return [
    {
      id: 'name',
      Header: t('list-name'),
      accessor: 'name',
      Cell: (props: CellProps<FormChecklistTemplate>) => (
        <TextLinkCell {...props} onClick={() => onOpen(props?.item)} />
      ),
      minWidth: 300,
      maxWidth: 500,
      width: 500,
      sortable: true,
    },
    {
      id: 'description',
      Header: t('description'),
      accessor: 'description',
      Cell: (props: CellProps<FormChecklistTemplate>) => (
        <CollapseCell {...props} minHeight={20} />
      ),
      minWidth: 300,
    },
    {
      id: 'optionsCount',
      Header: t('options-total'),
      accessor: 'optionsCount',
      Cell: (props: CellProps<FormChecklistTemplate>) => (
        <TextCell {...props} />
      ),
      minWidth: 200,
      maxWidth: 200,
      width: 200,
      sortable: true,
    },
  ];
}
